import styled from 'styled-components';

const TagIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &:hover {
    cursor: pointer;
  }

  svg {
    width: 80%;
    height: 80%;
    opacity: 0;
    fill: currentColor;
  }
`;

export default TagIcon;
